module.exports = __webpack_public_path__ + "static/media/HeartBeat.93f99bc8.gif";